import React from 'react';
import PropTypes from 'prop-types';
import { FootballIcon, VolleyballIcon, TrashIcon } from '../../../model/icons';
import { plMatch } from './betUtils';

// Карточка команды (.bt-team): имя, цвет, рейтинги и сыгранные матчи по видам спорта. onDelete — опциональная кнопка исключения из игры.
export default function TeamCard({ team, onDelete }) {
    return (
        <div className="bt-team">
            <div className="bh">
                <div className="bn">{team.name}</div>
                <div className="bh-right">
                    <span className="bdot" style={{ background: team.color }} />
                    {onDelete && (
                        <button type="button" className="bt-team-del" onClick={() => onDelete(team)} title="Убрать команду из игры">
                            <TrashIcon />
                        </button>
                    )}
                </div>
            </div>
            <SportRow icon={<FootballIcon />} label="Футбол" rating={team.ratingFootball} matches={team.matchesPlayedFootball} />
            <SportRow icon={<VolleyballIcon />} label="Волейбол" rating={team.ratingVolleyball} matches={team.matchesPlayedVolleyball} />
        </div>
    );
}

function SportRow({ icon, label, rating, matches }) {
    return (
        <div className="bt-sportrow">
            <span className="sico">{icon}</span>
            <div className="st">
                <div className="sl">{label}</div>
                <div className="sm">{plMatch(matches)}</div>
            </div>
            <div className="rv">{rating}</div>
        </div>
    );
}

SportRow.propTypes = {
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    rating: PropTypes.number,
    matches: PropTypes.number
};

TeamCard.propTypes = {
    team: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string.isRequired,
        color: PropTypes.string,
        ratingFootball: PropTypes.number,
        ratingVolleyball: PropTypes.number,
        matchesPlayedFootball: PropTypes.number,
        matchesPlayedVolleyball: PropTypes.number
    }).isRequired,
    onDelete: PropTypes.func
};

TeamCard.defaultProps = { onDelete: undefined };
